<template>
    <!-- <TopTab style="background: #FFAA96; position: relative;" /> -->
    <div class="category-more" v-if="showMoreList">
        <div class="search-bar">
            <div>
                <van-icon name="arrow-left" style="font-size: 26rem" @click="router.back()" />
            </div>
            <div style="width: 82%;">
                <van-search v-model="searchText" placeholder="请输入产品名称、标签、类型、发布者等其他关键词搜索您需要的内容" shape="round"
                    background="#F6F6F6" @search="onSearchClick" />
            </div>
            <div>
                <van-icon :name="icon44" style="font-size: 26rem" />
            </div>
        </div>
        <h5>全部分类</h5>
        <ul>
            <li v-for="item in categoryList" :class="{ active: item.id === activeCategory }"
                @click="onCategoryChange(item)">
                <img :src="item.picUrl" />
                <p>{{ item.name }}</p>
            </li>
        </ul>
        <div class="close" @click="showMoreList = false">
            点击收起
            <van-icon name="arrow-up" style="font-size: 16rem" />
        </div>
    </div>
    <div class="collection-container">
        <div class="collection-inner">
            <div class="search-bar">
                <div>
                    <van-icon name="arrow-left" style="font-size: 26rem" @click="router.back()" />
                </div>
                <div style="width: 82%;">
                    <van-search v-model="searchText" placeholder="请输入产品名称、标签、类型、发布者等其他关键词搜索您需要的内容" shape="round"
                        background="#F6F6F6" @search="onSearchClick" />
                </div>
                <div>
                    <van-icon :name="icon44" style="font-size: 26rem" />
                </div>
            </div>

            <div class="category-row" v-if="!showMoreList">
                <div class="category-tabs">
                    <ul>
                        <li v-for="item in categoryList" :class="{ active: item.id === activeCategory }"
                            @click="onCategoryChange(item)">
                            <img :src="item.picUrl" />
                            <p>{{ item.name }}</p>
                        </li>
                    </ul>
                </div>
                <div class="more_btn" @click="showMoreList = true">
                    <span>展开</span>
                    <van-icon :name="icon45" style="font-size: 18rem" />
                </div>
            </div>
        </div>

        <div class="list_container">
            <div class="filter_row">
                <div class="l">
                    <van-checkbox v-model="isFree" shape="square" icon-size="14rem" @change="onSearchClick">免费</van-checkbox>
                    <van-checkbox v-model="isCommercial" shape="square" icon-size="14rem" @change="onSearchClick">可商用</van-checkbox>
                </div>
                <div @click="showFilterDialog = true">
                    <van-icon :name="require('@/assets/imgs/icon46.png')" style="font-size: 26rem" />
                </div>
            </div>
            <div class="content">
                <div class="l">
                    <ul>
                        <li :class="{ active: activeSubCategory == '' }" @click="onSubCategoryChange({ id: '' })">
                            <p>全部</p>
                        </li>
                        <li v-for="item in subCategoryList" :class="{ active: item.id == activeSubCategory }"
                            @click="onSubCategoryChange(item)">
                            <p>{{ item.name }}</p>
                        </li>
                    </ul>
                </div>
                <div class="r">
                    <van-list v-model:loading="loading" :finished="finished" finished-text="没有更多了" @load="fetchList"
                        offset="100">
                        <div class="assets_card" v-for="item in list" @click="jumpToDetail(item)">
                            <img :src="item.picUrl.split(';')[0]" alt=""
                                :style="{ backgroundImage: 'url(' + (item.modelBgImage || 'https://dfsk-3d.oss-cn-shenzhen.aliyuncs.com/images/background01.png') + ')' }">
                            <div class="data">
                                <h6>{{ item.name }}</h6>
                                <div class="author" v-if="item.userPicUrl || item.userName">
                                    <img :src="item.userPicUrl" />
                                    <span>{{ item.userName }}</span>
                                </div>
                                <div class="info">
                                    <span><van-icon :name="require('@/assets/imgs/icon5.png')" size="14" /> {{
                                        item.browseCount || 0 }}</span>
                                    <span><van-icon :name="require('@/assets/imgs/icon6.png')" size="14" /> {{
                                        item.thumbsUpCount || 0 }}</span>
                                    <span><van-icon :name="require('@/assets/imgs/icon27.png')" size="14" /> {{
                                        item.liked
                                        || 0 }}</span>
                                    <span><van-icon :name="require('@/assets/imgs/icon26.png')" size="14" /> 0</span>
                                </div>
                            </div>

                        </div>
                    </van-list>
                </div>
            </div>
        </div>

        <div class="filter_wrapper" v-show="showFilterDialog">
            <h5>模型筛选</h5>
            <div class="row">
                <van-row :gutter="20">
                    <van-col :span="8">
                        <van-dropdown-menu>
                            <van-dropdown-item v-model="period" :options="periodList"  />
                        </van-dropdown-menu>
                    </van-col>
                    <van-col :span="8">
                        <van-dropdown-menu>
                            <van-dropdown-item v-model="assetsType" :options="assetsTypeOptions"  />
                        </van-dropdown-menu>
                    </van-col>
                    <van-col :span="8">
                        <van-dropdown-menu>
                            <van-dropdown-item v-model="format" :options="formatList"  />
                        </van-dropdown-menu>
                    </van-col>
                </van-row>
            </div>
            <div class="row">
                <van-row :gutter="20">
                    <van-col :span="8">
                        <van-dropdown-menu>
                            <van-dropdown-item v-model="isChartlet" :options="chartletOptions" title="贴图" />
                        </van-dropdown-menu>
                    </van-col>
                    <van-col :span="8">
                        <van-dropdown-menu>
                            <van-dropdown-item v-model="isMaterial" :options="materialOptions" title="材质" />
                        </van-dropdown-menu>
                    </van-col>
                    <van-col :span="8">
                        <van-dropdown-menu>
                            <van-dropdown-item v-model="isAnimation" :options="animationOptions" title="动画" />
                        </van-dropdown-menu>
                    </van-col>
                </van-row>
            </div>
            <div class="row">
                <div class="input-range">
                    <input type="number" v-model="lowPrice" placeholder="最低价格">
                    <div class="line"></div>
                    <input type="number" v-model="highPrice" placeholder="最高价格">
                </div>
            </div>
            <div class="row">
                <van-col :span="16">
                    <van-dropdown-menu>
                        <van-dropdown-item v-model="sortField" :options="sortOptions" />
                        <van-dropdown-item v-model="sortAsc" :options="sortAscOptions" />
                    </van-dropdown-menu>
                </van-col>
            </div>

            <footer>
                <div @click="showFilterDialog = false">取消</div>
                <div style="background: #FD0831; color: #FFF;" @click="onSearchClick">确定</div>
            </footer>
        </div>
    </div>

</template>

<script setup>
import TopTab from '@/views/front/components/TopTab.vue'
import { ref, onMounted, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { http } from '@/request/front'
import AssetsCard from '@/views/front/components/AssetsCard.vue'
import img1 from '@/assets/imgs/img1.png'
import FooterBar from '@/views/front/components/FooterBar.vue'
import icon44 from '@/assets/imgs/icon44.png'
import icon45 from '@/assets/imgs/icon45.png'
const router = useRouter()
const searchText = ref('')
const activeCategory = ref('')
const categoryList = ref([])
const subCategoryList = ref([])
const activeSubCategory = ref('')
const showMoreList = ref(true)
const list = ref([])
const loading = ref(false)
const showFilterDialog = ref(false)

function onSearchClick() {
    pageNo.value = 1
    list.value = []
    finished.value = false
    showFilterDialog.value = false
    fetchList()
}
const periodList = ref([])
const assetsTypeOptions = ref([{ text: '全部类型', value: '' }, { text: '模型', value: '模型' }, { text: '作品', value: '作品' }])
const formatList = ref([])
const chartletOptions = ref([{ text: '全部', value: '' }, { text: '有贴图', value: '1' }, { text: '无贴图', value: '0' }])
const materialOptions = ref([{ text: '全部', value: '' }, { text: '有材质', value: '1' }, { text: '无材质', value: '0' }])
const animationOptions = ref([{ text: '全部', value: '' }, { text: '有动画', value: '1' }, { text: '无动画', value: '0' }])
const sortOptions = ref([{ text: '热门', value: 'browseCount' }, { text: '最新', value: 'createTime' }, { text: '下载', value: 'downloadCount' }, { text: '价格', value: 'price' }])
const sortAscOptions = ref([{ text: '升序', value: true }, { text: '降序', value: false }])

const pageNo = ref(1)
const pageSize = 12
const finished = ref(false)
const isFree = ref(false)
const isCommercial = ref(false)
const period = ref('')
const assetsType = ref('')
const format = ref('')
const isChartlet = ref('')
const isMaterial = ref('')
const isAnimation = ref('')
const lowPrice = ref('')
const highPrice = ref('')
const sortField = ref('createTime')
const sortAsc = ref(true)
function fetchList() {
    loading.value = true
    http.get(`https://www.bolanzg.com/app-api/product/spu/page`, {
        params: {
            name: searchText.value,
            pageNo: pageNo.value,
            pageSize: pageSize,
            categoryId: activeSubCategory.value || activeCategory.value || '',
            modelFormat: format.value,
            period: period.value,
            isAnimation: isAnimation.value,
            isMaterial: isMaterial.value,
            isChartlet: isChartlet.value,
            isModel: assetsType.value == '模型' ? 1 : undefined,
            isWorks: assetsType.value == '作品' ? 1 : undefined,
            isFree: isFree.value ? 1 : undefined,
            isCommercial: isCommercial.value ? 1 : undefined,
            priceRange: lowPrice.value || highPrice.value ? `${lowPrice.value},${highPrice.value}` : undefined,
            sortField: sortField.value,
            sortAsc: sortAsc.value,
            type: 1
        }
    }).then(res => {
        console.log(res);
        loading.value = false
        pageNo.value++
        list.value.push(...res.data.data.list)
        finished.value = res.data.data.total <= list.value.length
    })

}

function onCategoryChange(data) {
    showMoreList.value = false
    subCategoryList.value = data.children || []
    activeCategory.value = data.id
    onSubCategoryChange({ id: '' })
}

function onSubCategoryChange(item) {
    activeSubCategory.value = item.id
    pageNo.value = 1
    list.value = []
    finished.value = false
    fetchList()
}

function jumpToDetail(item) {
    router.replace({ path: '/assets-detail', query: { id: item.id } })
    window.scrollTo(0, 0)
}
const route = useRoute()
onMounted(() => {
    fetchList()
    http.get('https://www.bolanzg.com/app-api/product/category/treeList').then(res => {
        categoryList.value = res.data.data
        if (route.query.id) {
            activeCategory.value = route.query.id
            const item = categoryList.value.find(item => item.id == route.query.id)

            onCategoryChange(item)
        } else {
            onCategoryChange(categoryList.value[0])
        }
    })
    http.get('https://www.bolanzg.com/app-api/model/period/page?pageNo=1&pageSize=100').then(res => {
        periodList.value = res.data.data.list.map(item => {
            return {
                text: item.name,
                value: item.id,
            }
        })
        periodList.value.unshift({
            text: '全部时期',
            value: '',
        })
        console.log(periodList.value);

    })

    http.get('https://www.bolanzg.com/app-api/product/category/format-list').then(res => {
        formatList.value = res.data.data.map(item => {
            return {
                text: item,
                value: item,
            }
        })
        formatList.value.unshift({
            text: '全部格式',
            value: '',
        })
    })
})
</script>

<style scoped lang="scss">
.collection-container {
    min-height: 100vh;
    background-color: #F6F6F6;

    .collection-inner {
        position: relative;
        padding: 15rem;
        min-height: 300rem;
        background: linear-gradient(180deg, #FFAA96 0%, #FFF 100%);
    }
}

.search-bar {
    margin: 12rem 0;
    display: flex;
    align-items: center;
    justify-content: space-between;

    ::v-deep(.van-search) {
        border-radius: 16rem;
        height: 32rem;

        .van-search__field {
            height: 32rem;

            .van-field__control {
                font-size: 12rem;
            }
        }
    }
}

.category-row {
    display: flex;
    position: relative;

    .more_btn {
        width: 30rem;
        height: 80rem;
        top: 0;
        right: 0rem;
        position: absolute;
        text-align: center;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    .category-tabs {
        padding: 10rem 0;
        width: calc(100% - 30rem);
        overflow-x: scroll;

        ul {
            display: flex;
            align-items: center;

            li {
                width: 100rem;
                margin: 0 10rem;
                display: flex;
                flex-direction: column;
                align-items: center;
                
                img {
                    width: 50rem;
                    height: 50rem;
                    object-fit: cover;
                    border-radius: 50%;
                    background: linear-gradient(180deg, rgba(204, 204, 204, 0) 0%, rgba(204, 204, 204, 1) 100%);
                }

                p {
                    font-size: 12rem;
                    margin-top: 5rem;
                    height: 20rem;
                    min-width: 60rem;
                    padding: 0 10rem;
                    text-align: center;
                    white-space: nowrap;
                }
            }

            .active {
                img {
                    border: 2rem solid #000;
                }

                p {
                    background-color: #000;
                    color: #FFF;
                    border-radius: 10rem;
                }
            }
        }
    }

    .category-tabs::-webkit-scrollbar {
        display: none;
    }
}

.category-more {
    position: absolute;
    z-index: 11;
    width: 100vw;
    height: 390rem;
    top: 0;
    left: 0;
    border-radius: 10rem;
    background: linear-gradient(180deg, #FFAA96 0%, #FFF 50%);

    h5 {
        padding: 10rem 30rem;
    }

    ul {
        padding: 0 20rem;
        height: 250rem;
        overflow-y: scroll;

        li {
            margin: 5rem 0;
            width: 78rem;

            float: left;
            display: flex;
            flex-direction: column;
            align-items: center;

            img {
                width: 50rem;
                height: 50rem;
                object-fit: cover;
                border-radius: 50%;
                background: linear-gradient(180deg, rgba(204, 204, 204, 0) 0%, rgba(204, 204, 204, 1) 100%);
            }

            p {
                font-size: 12rem;
                min-width: 60rem;
                padding: 0 10rem;
                margin-top: 5rem;
                text-align: center;
                white-space: nowrap;
                color: #5C5C5C;
            }
        }


        .active {
            img {
                border: 2rem solid #000;
            }

            p {
                background-color: #000;
                color: #FFF;
                border-radius: 10rem;
            }
        }
    }

    .close {
        margin: 0 30rem;
        border-top: 1px solid #E9E9E9;
        text-align: center;
        height: 40rem;
        line-height: 40rem;
        color: #808080;
    }
}


.list_wrap {
    position: relative;
}

.waterfall-grid {
    display: flex;
    padding: 15rem;
    gap: 15rem;

    .waterfall-column {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: 12px;
    }

    .waterfall-item {
        background: #fff;
        overflow: hidden;

        img {
            width: 100%;
            display: block;
        }

        .item-info {
            padding: 10px;

            h6 {
                font-size: 14px;
                margin: 0 0 8px 0;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }

            .item-stats {
                display: flex;
                gap: 12px;
                font-size: 12px;
                color: #999;

                span {
                    display: flex;
                    align-items: center;
                    gap: 4px;
                }
            }
        }
    }
}

.loading {
    text-align: center;
    padding: 20px;
}

.list_container {
    width: 100%;
    height: calc(100vh - 180rem);
    position: absolute;
    bottom: 0;
    background-color: #fff;
    border-radius: 20rem 20rem 0 0;

    .filter_row {
        height: 55rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 15rem;
        border-bottom: 1px solid #F6F6F6;

        .l {
            display: flex;
            align-items: center;
            gap: 10rem;
            border: 1px solid #E9E9E9;
            height: 30rem;
            border-radius: 13rem;
            padding: 0 10rem;

            ::v-deep(.van-checkbox__label) {
                color: #999;
            }
        }
    }

    .content {
        width: 100%;
        height: calc(100% - 55rem);
        display: flex;

        .l {
            width: 86rem;
            height: 100%;
            background-color: #F5F5F5;
            overflow-y: scroll;

            ul {
                li {
                    height: 44rem;
                    line-height: 44rem;
                    text-align: center;
                    p{
                        color: #808080;
                        font-size: 14rem;
                    }
                }

                .active {
                    background-color: #FFF;
                    p{
                        color: #000;
                    }
                }
            }
        }

        .r {
            width: calc(100% - 86rem);
            height: 100%;
            background-color: #fff;
            overflow-y: scroll;
            padding: 0 10rem;

            .assets_card {
                display: flex;
                margin-bottom: 10rem;
                height: 120rem;

                img {
                    width: 120rem;
                    height: 120rem;
                    object-fit: cover;
                    background-size: cover;
                }

                .data {
                    padding: 5rem 10rem;
                    width: 100%;

                    .author {
                        margin-bottom: 5rem;
                        color: #999999;

                        img {
                            width: 20rem;
                            height: 20rem;
                            margin-right: 10rem;
                            border-radius: 50%;
                        }
                    }

                    .info {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        width: 100%;
                        color: #999999;
                        font-size: 12rem;

                        span {
                            display: flex;
                            align-items: center;

                            i {
                                margin-right: 5rem;
                            }
                        }
                    }

                    h6 {
                        line-height: 24rem;
                        font-size: 14rem;
                        height: 60rem;
                    }
                }
            }
        }
    }
}

.filter_wrapper {
    width: 100vw;
    height: 600rem;
    background-color: #fff;
    position: absolute;
    top: 0;
    left: 0;
    padding: 20rem;
    border-radius: 0 0 10rem 10rem;
    overflow: hidden;
    h5 {
        text-align: center;
        height: 40rem;
        line-height: 40rem;
        font-size: 16rem;
    }
    .row{
        margin: 20rem 0;
        ::v-deep(.van-dropdown-menu){
            border: 1px solid #E9E9E9;
            .van-dropdown-menu__bar{
                box-shadow: none;
                height: 32rem;
                .van-ellipsis{
                    font-size: 14rem;
                }
            }
        }
        .input-range{
            height: 32rem; border: 1px solid #E9E9E9; display: flex; align-items: center;
            gap: 10rem;
            padding: 0 10rem;
            input{width: 45%; text-align: center;}
            .line{width: 16rem; height: 1px; background-color: #808080;}
        }
    }
    footer{
        position: absolute; bottom: 0; left: 0; width: 100%; display: flex;
        div{
            width: 50%; height: 50rem; line-height: 50rem; background-color: #E5E5E5; text-align: center;
        }
    }
}
</style>
